import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22b1f739"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "md:pl-xxl" }
const _hoisted_2 = { class: "flex items-stretch justify-between transition-all ease-in h-14 md:h-16" }
const _hoisted_3 = {
  id: "left-nav-block",
  class: "flex items-center md:hidden",
  "data-test-left-nav-block": ""
}
const _hoisted_4 = {
  class: "flex items-center",
  "data-test-navigation-wrapper": ""
}
const _hoisted_5 = {
  class: "h-full items-center flex-shrink-0 text-gray-100 h-full w-28 py-3 hidden sm:flex",
  "data-test-logo-wrapper": ""
}
const _hoisted_6 = {
  class: "hidden md:block",
  "data-test-navigation-items-wrapper": ""
}
const _hoisted_7 = { class: "ml-10 flex items-baseline space-x-4" }
const _hoisted_8 = ["aria-current", "href", "data-test-navigation-item", "onClick"]
const _hoisted_9 = {
  id: "right-nav-block",
  class: "flex place-content-end relative bg-primary before:absolute before:block before:w-10 before:top-0 before:bottom-0 before:-left-4 before:bg-primary before:border before:border-primary before:transform before:skew-x-20 before:origin-top-left before:rounded-bl-[.625rem]",
  "data-test-right-nav-block": ""
}
const _hoisted_10 = { class: "relative md:ml-4 flex items-stretch" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, " Open gebruiker menu ", -1))
const _hoisted_12 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainMenuMobile = _resolveComponent("MainMenuMobile")!
  const _component_CompanyLogo = _resolveComponent("CompanyLogo")!
  const _component_KennissLogo = _resolveComponent("KennissLogo")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_AppBadge = _resolveComponent("AppBadge")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_AppDropdownMenu = _resolveComponent("AppDropdownMenu")!
  const _component_AppAvatar = _resolveComponent("AppAvatar")!

  return (_openBlock(), _createElementBlock("nav", {
    id: "primary-nav",
    class: _normalizeClass([_ctx.dynamicDomClasses, "bg-gray-900"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_MainMenuMobile, { "navigation-items": _ctx.permittedItems }, null, 8, ["navigation-items"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_RouterLink, {
              to: _ctx.dashboardRoute,
              class: "block w-full h-full"
            }, {
              default: _withCtx(() => [
                (_ctx.company?.logoHtml.light)
                  ? (_openBlock(), _createBlock(_component_CompanyLogo, {
                      key: 0,
                      "logo-html": _ctx.company.logoHtml.light
                    }, null, 8, ["logo-html"]))
                  : (_openBlock(), _createBlock(_component_KennissLogo, {
                      key: 1,
                      class: "w-full text-gray-400 hover:text-white fill-current"
                    }))
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permittedItems, (item) => {
                return (_openBlock(), _createBlock(_component_RouterLink, {
                  key: item.name,
                  to: item.href,
                  custom: ""
                }, {
                  default: _withCtx(({ href, navigate, isActive }) => [
                    _createElementVNode("a", {
                      "aria-current": isActive ? 'page' : undefined,
                      class: _normalizeClass([
                    isActive || _ctx.navigationItemIsActive(item.name)
                      ? 'bg-black text-white primary-nav-link--active'
                      : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                    'px-3 py-2 text-sm rounded-t-sm font-medium primary-nav-link block',
                  ]),
                      href: href,
                      "data-test-navigation-item": item.name,
                      onClick: navigate
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t(item.name)) + " ", 1),
                      (item.name === 'navigation.myDocuments' && _ctx.user?.signDocumentsCount > 0)
                        ? (_openBlock(), _createBlock(_component_AppBadge, {
                            key: 0,
                            size: "small",
                            class: "bg-red-100 text-red-900 ml-1 !mb-0"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.user.signDocumentsCount), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_8)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128)),
              (_ctx.user?.menuItems?.length)
                ? (_openBlock(), _createBlock(_component_AppDropdownMenu, {
                    key: 0,
                    "align-center": true,
                    items: _ctx.extraMenuItems,
                    "extended-menu-items-dom-classes": "!w-min !mt-4 !z-80 bg-gray-900",
                    "extended-menu-item-dom-classes": "justify-center px-8 !text-gray-300 hover:!text-white hover:bg-gray-700",
                    "extended-active-menu-item-dom-classes": "!text-white !bg-gray-700",
                    "data-test-extra-menu-items-dropdown": ""
                  }, {
                    trigger: _withCtx(() => [
                      _createVNode(_component_MenuButton, { class: "primary-nav-link inline-flex items-center gap-2 px-3 py-2 text-sm !outline-none rounded-t-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('more')), 1),
                          _createVNode(_component_ChevronDownIcon, {
                            class: "w-5 h-5",
                            "aria-hidden": "true"
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["items"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_AppDropdownMenu, {
              items: _ctx.userNavigation,
              class: "account-dropdown",
              "extended-menu-items-dom-classes": "!-mt-2 !z-80"
            }, {
              trigger: _withCtx(() => [
                _createVNode(_component_MenuButton, { class: "relative max-w-xs flex items-center text-sm hover:text-black focus:outline-none px-0 md:pr-xxl md:pl-xl" }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    (_ctx.user?.name)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          title: _ctx.user.name,
                          "data-test-user-name": "",
                          class: "hidden pl-3 pr-5 text-primary-opposite-color whitespace-nowrap overflow-hidden overflow-ellipsis sm:inline"
                        }, _toDisplayString(_ctx.user.name), 9, _hoisted_12))
                      : _createCommentVNode("", true),
                    (_ctx.user)
                      ? (_openBlock(), _createBlock(_component_AppAvatar, {
                          key: 1,
                          src: _ctx.user?.avatarUrl,
                          name: _ctx.user?.name,
                          class: "!bg-gray-200 !text-gray-900 flex-grow"
                        }, null, 8, ["src", "name"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ChevronDownIcon, {
                      class: "chevron-down-icon hidden w-5 h-5 ml-2 -mr-1 flex-grow text-primary-opposite-color xs:block",
                      "aria-hidden": "true"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["items"])
          ])
        ])
      ])
    ])
  ], 2))
}